// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const buscarInfoUsuarioByInteresseId = async (interesseId: number) => {
  const Token = validateToken();

  console.log("Iniciando busca de info do usuario interesse para interesseId:", interesseId);

  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/interesse/info-usuario/${interesseId}`;

    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      if (response && response.data) {

        console.log("Dados de info do usuario recebidos no service:", response.data);
        return response.data;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
